import { createFileRoute } from '@tanstack/react-router';

/**
 * Whole-study preview. Split from its component so the eager half of the route stays free of
 * `@askable/study-flow` and its native peers; `studies.$studyId.preview.lazy.tsx` holds the rest.
 *
 * No loader: the gate is a Statsig read through React context, so a loader would fetch the study
 * for researchers who never get past the gate.
 */
export const Route = createFileRoute('/studies/$studyId/preview')({});
